import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDownIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-chevron-down", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polyline", { points: "6 9 12 15 18 9" }));
const ForwardRef = forwardRef(SvgChevronDownIcon);
export { ForwardRef as ReactComponent };
